import { render, staticRenderFns } from "./InvestmentsDeal.vue?vue&type=template&id=452cadac&scoped=true"
import script from "./InvestmentsDeal.vue?vue&type=script&lang=js"
export * from "./InvestmentsDeal.vue?vue&type=script&lang=js"
import style0 from "./InvestmentsDeal.vue?vue&type=style&index=0&id=452cadac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452cadac",
  null
  
)

export default component.exports